// extracted by mini-css-extract-plugin
export var brand = "_bh-9";
export var compact = "_bh-6";
export var extraSmall = "_bh-7";
export var icon = "_bh-0";
export var large = "_bh-4";
export var light = "_bh-1";
export var medium = "_bh-5";
export var outline = "_bh-b";
export var primaryDark = "_bh-a";
export var primaryLight = "_bh-8";
export var primaryModern = "_bh-c";
export var success = "_bh-2";
export var successSolid = "_bh-3";